import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  parts: ["input", "tokenLabel", "maxButton", "errorMessage"],
  baseStyle: {
    input: {
      width: "full",
      height: "104px",
      bg: "primary.white.100",
      borderWidth: 1,
      borderStyle: "solid",
      outline: "none",
      paddingLeft: 6,
    },
    maxButton: {
      variant: "primary",
      px: "16px",
      py: "8px",
      rounded: "24px",
      position: "absolute",
      top: "36px",
      mr: 6,
      right: "0px",
      zIndex: 11,
      textTransform: "uppercase",
      _disabled: {
        background: "primary.black.20",
        cursor: "not-allowed",
        _hover: { background: "primary.black.20" },
      },
    },
    errorMessage: {
      variant: "label",
      color: "primary.red.100",
      position: "absolute",
      bottom: 2,
      left: 6,
      zIndex: 10,
    },
  },
  variants: {},
  sizes: {
    md: {
      input: {
        size: "md",
        fontSize: "26px",
        lineHeight: "32px",
        fontWeight: 500,
      },
      maxButton: {
        fontWeight: 700,
        fontFamily: "riforma.bold",
        fontSize: "12px",
      },
    },
    lg: {
      input: {
        size: "lg",
        fontSize: "38px",
        lineHeight: "32px",
        fontWeight: 400,
      },
      maxButton: {
        fontWeight: 700,
        fontFamily: "riforma.bold",
        fontSize: "12px",
      },
    },
  },
  defaultProps: {
    size: "lg",
  },
})

export default theme
